var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{ref:"modal",attrs:{"title":_vm.title}},[_c('user-roles',{attrs:{"user-id":_vm.user.id},on:{"assigned":_vm.assign,"unassigned":_vm.unassign}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }